import {inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export class DialogBase<Data, Result> {
    protected dialogRef = inject<MatDialogRef<this, Result>>(MatDialogRef);
    protected data = inject<Data>(MAT_DIALOG_DATA);
}